import { PackageActivationTableContainer } from './PackageActivationTable';

export const PackageActivationPage = () => (
    <div>
        <PackageActivationTableContainer />
    </div>
);
